import axios, { getData } from 'lib/axios'

export const getModuleDetails = async (id) => {
  const { data } = await axios.get(`adx_edu/my_class/${id}`).then(getData)
  return data
}

export const postProgress = async (payload) => {
  return await axios.post(`adx_edu/recording/log`, payload)
}